import { NetInfoStateType, useNetInfo } from '@react-native-community/netinfo';

import { StreamTypes } from 'store/player/actions.types';
import { RBChannel } from 'store/railsBuilder/reducer.types';

import { VideoItem } from 'services/data-manager/types';

import { convertStringToBoolean } from 'utils/convertStringToBoolean';

export enum OOHStreamTypes {
    LIVE = 'clientMobileLiveOOHStreamingControl',
    SO = 'clientMobileRestartOOHControl',
    CU = 'clientMobileOOHCatchupControl',
    NPVR = 'clientMobileOOHNpvrControl',
    VOD = 'clientMobileVODOOHControl',
}

const oohStreamTypeMap = {
    [StreamTypes.catchup]: OOHStreamTypes.CU,
    [StreamTypes.live]: OOHStreamTypes.LIVE,
    [StreamTypes.startover]: OOHStreamTypes.SO,
    [StreamTypes.npvr]: OOHStreamTypes.NPVR,
    [StreamTypes.vod]: OOHStreamTypes.VOD,
};

export default function useInHomeDetectionBlockStream(
    channel: RBChannel | undefined,
    videoItem: VideoItem | undefined,
    playbackType: StreamTypes | undefined,
) {
    const { type } = useNetInfo();
    const isCellular = type === NetInfoStateType.cellular;
    let oohEnabled = false;

    if (!playbackType) {
        return {
            outOfHomeBlockStream: false,
        };
    }

    if (videoItem != null) {
        const assetValue = videoItem.oohConfig?.[playbackType];

        if (assetValue != null) {
            oohEnabled = convertStringToBoolean(assetValue);
        } else if (channel != null) {
            const oohType = oohStreamTypeMap[playbackType];
            const channelValue = channel.editorial[oohType];

            if (channelValue != null) {
                oohEnabled = convertStringToBoolean(channelValue);
            }
        }
    }

    return {
        outOfHomeBlockStream: isCellular && !oohEnabled,
    };
}
